export default class CatalogEventConst {
    static CLICK='event-click'
    static CHANGE='event-change'
    static CUSTOM='event-custom'
    static ONACTIVATED='event-onactivated'
    static ONBEFOREMOUNTED='event-onbeforemount'
    static ONBEFOREUNMOUNT='event-onbeforeunmounted'
    static ONBEFOREUPDATE ='event-onbeforeupdate'
    static ONDEACTIVATED='event-ondeactivated'
    static ONERRORCAPTURED='event-onerrorcapture'
    static ONMOUNTED='event-onmounted'
    static ONUNMOUNTED='event-onunmounted'
    static ONUPDATED ='event-onupdate'
    
    }
    